
import { supabase } from '@/integrations/supabase/client';

/**
 * Fetches employees (admin users)
 */
export const fetchEmployees = async () => {
  try {
    const { data, error } = await supabase
      .from('client_onboarding')
      .select('*')
      .eq('role', 'admin')
      .order('created_at', { ascending: false });

    if (error) {
      throw error;
    }

    return { data: data || [] };
  } catch (error) {
    console.error('Error fetching employees:', error);
    return { data: [], error };
  }
};

/**
 * Removes an employee from the system
 */
export const removeEmployee = async (employeeId: string) => {
  try {
    // Get employee email before removal
    const { data: employee, error: fetchError } = await supabase
      .from('client_onboarding')
      .select('email')
      .eq('id', employeeId)
      .single();

    if (fetchError) throw fetchError;

    // Remove the employee from client_onboarding
    const { error: deleteError } = await supabase
      .from('client_onboarding')
      .delete()
      .eq('id', employeeId);

    if (deleteError) throw deleteError;

    return { success: true };
  } catch (error) {
    console.error('Error removing employee:', error);
    return { success: false, error };
  }
};

/**
 * Toggles an employee's active status
 */
export const toggleEmployeeActiveStatus = async (employeeId: string, isActive: boolean) => {
  try {
    console.log(`Toggling active status for employee ID ${employeeId} to ${isActive}`);
    
    const { data, error } = await supabase
      .from('client_onboarding')
      .update({ 
        is_active: isActive,
        updated_at: new Date().toISOString()
      })
      .eq('id', employeeId)
      .select();

    if (error) {
      console.error("Error toggling employee active status:", error);
      throw error;
    }
    
    return { 
      success: true, 
      updatedEmployee: data && data.length > 0 ? data[0] : null
    };
  } catch (error) {
    console.error('Error toggling employee active status:', error);
    return { success: false, error };
  }
};

/**
 * Add a new employee manually
 */
export const addEmployee = async (employeeData: any) => {
  try {
    console.log('Adding new employee:', employeeData);
    
    const { data, error } = await supabase
      .from('client_onboarding')
      .insert({
        full_name: employeeData.fullName,
        email: employeeData.email,
        company_name: employeeData.companyName || null,
        phone: employeeData.phone || null,
        status: 'verified',
        role: 'admin',
        is_active: true
      })
      .select();
      
    if (error) {
      console.error("Error adding employee:", error);
      throw error;
    }
    
    return { 
      success: true, 
      employee: data && data.length > 0 ? data[0] : null
    };
  } catch (error) {
    console.error('Error adding employee:', error);
    return { success: false, error };
  }
};
